import { clearGraphData, setGraphMetrics } from '../actions';

const clearGraphResources = () => dispatch => {
    dispatch(clearGraphData());
    dispatch(setGraphMetrics([]));
};

export default clearGraphResources;
